'use client';

import { useEffect } from 'react';
import { reportWebVitals } from '@/lib/analytics/webVitals';

/**
 * Client component that initializes Web Vitals reporting
 * Add this to your root layout to track Core Web Vitals
 */
export default function WebVitalsReporter() {
  useEffect(() => {
    reportWebVitals();
  }, []);

  return null;
}
